// Real data for City Trafikskola Uppsala AB
// Source: https://www.citytrafikskolauppsala.se/

export const school = {
  name: "City Trafikskola",
  legalName: "City Trafikskola Uppsala AB",
  city: "Uppsala",
  tagline: "Trafikskola i Uppsala",
  email: "info@citytrafikskolauppsala.se",
  swish: "123 377 74 30",
  address: "Torkelsgatan 29",
  postal: "754 21 Uppsala",
  area: "Kvarntorget",
  bookingUrl: "https://elev.citytrafikskolauppsala.se/shop",
  bookingUrlKorpaket: "https://elev.citytrafikskolauppsala.se/shop/korpaket",
  hours: [
    { day: "Måndag", time: "07:30 - 17:40" },
    { day: "Tisdag", time: "07:30 - 17:40" },
    { day: "Onsdag", time: "07:30 - 17:40" },
    { day: "Torsdag", time: "07:30 - 17:40" },
    { day: "Fredag", time: "07:30 - 17:40" },
    { day: "Lördag", time: "Enligt överenskommelse" },
    { day: "Söndag", time: "Enligt överenskommelse" },
  ],
  hoursTitle: "Körtider",
  reception: "Receptionen har öppet vardagar 10:00 - 17:00 (lunchstängt 12:00 - 13:00).",
  hoursNote:
    "Receptionen har öppet vardagar 10:00 - 17:00, lunchstängt 12:00 - 13:00. Lördag och söndag är receptionen obemannad, men vi har öppet för inbokade kurser och körlektioner enligt överenskommelse.",
  social: { facebook: "https://www.facebook.com/citytrafikskola018/", instagram: "https://www.instagram.com/citytrafikskola018/" },
};

export const nav = [
  { label: "Hem", path: "/" },
  { label: "Paket och priser", path: "/priser" },
  { label: "Utbildning", path: "/om-oss" },
  { label: "Omdömen", path: "/omdomen" },
  { label: "Teoricentralen", path: "/teori" },
  { label: "Kontakt", path: "/kontakt" },
];

export const heroImage =
  "https://images.unsplash.com/photo-1553782097-130fef5d3e27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxkcml2aW5nJTIwc2Nob29sfGVufDB8fHx8MTc5MDE1NDMzNnww&ixlib=rb-4.1.0&q=85";

// Hero background: real city drive through Uppsala via YouTube embed (plays 2 minutes starting at 5:00).
export const heroYouTubeId = "u6nK415uca4";
export const heroVideoStart = 300;
export const heroVideoEnd = 420;
// Self-hosted hero clip (upload to frontend/public/video/hero.mp4) – used on all devices when present.
export const heroMp4 = "/video/hero.mp4";

// Original brand assets provided by City Trafikskola Uppsala
export const logo = "/img/logo-transparent.png";
export const images = {
  uppsala: "/img/uppsala.webp",
  reception: "/img/reception.jpg",
};

// Real upcoming course dates from https://elev.citytrafikskolauppsala.se/shop/kurser
export const coursesUrl = "https://elev.citytrafikskolauppsala.se/shop/kurser";
export const upcoming = [
  {
    title: "Halkbana (riskutbildning del 2)",
    detail: "Torsdag 1 oktober · 08:00–14:00 · Torkelsgatan 29",
    spots: "4 platser kvar",
    price: "2 100 kr",
    date: { day: "01", month: "OKT" },
    url: "https://elev.citytrafikskolauppsala.se/shop/kurser/riskutbildning-del-2-b-halkbana",
  },
  {
    title: "Riskettan (riskutbildning del 1)",
    detail: "Torsdag 8 oktober · 17:00–20:00 · Torkelsgatan 29",
    spots: "Fler än 5 platser kvar",
    price: "500 kr",
    date: { day: "08", month: "OKT" },
    url: "https://elev.citytrafikskolauppsala.se/shop/kurser/riskutbildning-del-1-b",
  },
  {
    title: "Halkbana (riskutbildning del 2)",
    detail: "Torsdag 8 oktober · 08:00–14:00 · Torkelsgatan 29",
    spots: "4 platser kvar",
    price: "2 100 kr",
    date: { day: "08", month: "OKT" },
    url: "https://elev.citytrafikskolauppsala.se/shop/kurser/riskutbildning-del-2-b-halkbana",
  },
];
export const riskPaket = {
  title: "Risk 1 & 2 paketpris",
  price: "2 250 kr",
  ord: "2 600 kr",
  url: "https://elev.citytrafikskolauppsala.se/shop/kurser/risk-1-2-paketpris",
};

// Ordinarie styckpriser (härledda ur paketens ordinarie priser) – används av prisjämföraren
export const unitPrices = { lesson: 995, riskettan: 500, halkbana: 2100, teori: 1200, riskPaket: 2250 };

// Digital services – book, reschedule and study online
export const digital = [
  { icon: "CalendarCheck", title: "Boka online 24/7", text: "Boka körlektioner, kurser och paket direkt i vår elevportal – när det passar dig." },
  { icon: "RefreshCw", title: "Omboka själv", text: "Behöver du flytta en lektion? Omboka enkelt digitalt utan att ringa eller mejla." },
  { icon: "Smartphone", title: "Allt i mobilen", text: "Se dina bokningar, kvitton och din utbildningsplan direkt i mobilen." },
  { icon: "BookOpen", title: "Teoricentralen", text: "Digital teoribok och online teoritester på sex språk – plugga var du vill." },
];

export const steps = [
  { n: 1, title: "Ansök om tillstånd", text: "Vi hjälper dig att ansöka om körkortstillstånd hos Transportstyrelsen." },
  { n: 2, title: "Välj ditt paket", text: "Startpaket, körpaket eller intensivpaket – du väljer takt och upplägg." },
  { n: 3, title: "Genomför utbildningen", text: "Teori, körlektioner à 60 min, riskettan och halkbana." },
  { n: 4, title: "Klara provet", text: "Vi förbereder dig hela vägen fram till teori- och körprovet." },
];

export const features = [
  { icon: "Languages", title: "Teori på sex språk", text: "Böcker och dataprov på svenska, engelska, arabiska, turkiska, kurdiska och persiska." },
  { icon: "GraduationCap", title: "Flerspråkiga lärare", text: "Våra lärare undervisar även på arabiska, turkiska, kurdiska och persiska." },
  { icon: "ShieldCheck", title: "Riskettan & Halkbana", text: "Vi erbjuder båda de obligatoriska riskutbildningarna på plats i Uppsala." },
  { icon: "Car", title: "Moderna bilar", text: "Vi kör i Volkswagen T-Cross – både manuell och automat." },
  { icon: "CalendarCheck", title: "Boka & omboka online", text: "Sköt allt praktiskt digitalt i elevportalen – dygnet runt, direkt i mobilen." },
];

// Real packages from citytrafikskolauppsala.se
export const packageCategories = [
  {
    key: "start",
    title: "Startpaket",
    subtitle: "Komplett start mot körkortet – teori och riskettan ingår.",
    items: [
      {
        name: "Startpaket 1",
        price: "6 425 kr",
        ord: "6 675 kr",
        save: "Rabatt 250 kr",
        popular: false,
        features: [
          "5 st körlektioner à 60 minuter (5 timmars körning)",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
        ],
      },
      {
        name: "Startpaket 2",
        price: "10 900 kr",
        ord: "11 650 kr",
        save: "Rabatt 750 kr",
        popular: true,
        features: [
          "10 st körlektioner à 60 minuter (10 timmars körning)",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
        ],
      },
      {
        name: "Startpaket 3",
        price: "12 250 kr",
        ord: "13 750 kr",
        save: "Rabatt 1 500 kr",
        popular: false,
        features: [
          "10 st körlektioner à 60 minuter (10 timmars körning)",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
          "Halkbana (riskutbildning del 2)",
        ],
      },
    ],
  },
  {
    key: "kor",
    title: "Körpaket",
    subtitle: "För dig som redan har tillstånd och bara behöver köra.",
    items: [
      { name: "Körpaket 1", price: "4 725 kr", ord: "4 975 kr", save: "Rabatt 250 kr", features: ["5 körlektioner à 60 minuter (5x60min)"] },
      { name: "Körpaket 2", price: "9 200 kr", ord: "9 950 kr", save: "Rabatt 750 kr", features: ["10 körlektioner à 60 minuter (10x60min)"] },
      { name: "Körpaket 3", price: "13 425 kr", ord: "14 925 kr", save: "Rabatt 1 500 kr", features: ["15 körlektioner à 60 minuter (15x60min)"] },
      { name: "Körpaket 4", price: "17 900 kr", ord: "19 900 kr", save: "Rabatt 2 000 kr", features: ["20 körlektioner à 60 minuter (20x60min)"] },
    ],
  },
  {
    key: "intensiv",
    title: "Intensivpaket",
    subtitle: "Ta körkortet i komprimerat tempo – allt du behöver ingår.",
    items: [
      {
        name: "Intensivpaket Standard",
        price: "18 725 kr",
        ord: "20 625 kr",
        save: "Rabatt 1 900 kr",
        popular: false,
        features: [
          "15 körlektioner à 60 minuter (15x60min)",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
          "Halkbana (riskutbildning del 2)",
          "Uppvärmningslektion á 40 min",
          "Lån av bil",
        ],
      },
      {
        name: "Intensivpaket Mellan",
        price: "23 500 kr",
        ord: "25 600 kr",
        save: "Rabatt 2 100 kr",
        popular: true,
        features: [
          "20 körlektioner à 60 minuter (20x60min)",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
          "Halkbana (riskutbildning del 2)",
          "Uppvärmningslektion á 40 min",
          "Lån av bil",
        ],
      },
    ],
  },
  {
    key: "start40",
    title: "Startpaket 40 min",
    subtitle: "Samma kompletta start – med kortare körlektioner på 40 minuter. Teori och riskettan ingår.",
    duration: 40,
    items: [
      {
        name: "Startpaket Flex 5",
        price: "4 850 kr",
        ord: "5 025 kr",
        save: "Rabatt 175 kr",
        popular: false,
        features: [
          "5 st körlektioner à 40 minuter",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
        ],
      },
      {
        name: "Startpaket Flex 10",
        price: "7 850 kr",
        ord: "8 350 kr",
        save: "Rabatt 500 kr",
        popular: true,
        features: [
          "10 st körlektioner à 40 minuter",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
        ],
      },
      {
        name: "Startpaket Flex 10 Plus",
        price: "9 450 kr",
        ord: "10 450 kr",
        save: "Rabatt 1 000 kr",
        popular: false,
        features: [
          "10 st körlektioner à 40 minuter",
          "Egen inloggning till online teoritester",
          "Digital teoribok",
          "Riskettan",
          "Halkbana (riskutbildning del 2)",
        ],
      },
    ],
  },
  {
    key: "kor40",
    title: "Körpaket 40 min",
    subtitle: "Kortare, flexibla körlektioner på 40 minuter – perfekt när du vill köra oftare.",
    duration: 40,
    items: [
      { name: "Körpaket Flex 5", price: "3 225 kr", ord: "3 325 kr", save: "Rabatt 100 kr", features: ["5 körlektioner à 40 minuter (5x40min)"] },
      { name: "Körpaket Flex 10", price: "6 250 kr", ord: "6 650 kr", save: "Rabatt 400 kr", popular: true, features: ["10 körlektioner à 40 minuter (10x40min)"] },
      { name: "Körpaket Flex 15", price: "9 150 kr", ord: "9 975 kr", save: "Rabatt 825 kr", features: ["15 körlektioner à 40 minuter (15x40min)"] },
      { name: "Körpaket Flex 20", price: "11 300 kr", ord: "13 300 kr", save: "Rabatt 2 000 kr", features: ["20 körlektioner à 40 minuter (20x40min)"] },
    ],
  },
];

export const lessonCount = (p) => parseInt((p.features.find((f) => /körlektion/i.test(f)) || "").match(/\d+/)?.[0] || "0", 10);
export const lessonFeature = (f) => /körlektion/i.test(f);
export const extraFeatures = (p) => {
  const rest = p.features.filter((f) => !lessonFeature(f));
  return rest.length ? rest : ["Endast körlektioner – boka tider när det passar dig", "Kan kombineras med riskettan och halkbana"];
};

// Visningsordning: körpaket först, 40 min före 60 min
const categoryOrder = ["kor40", "start40", "kor", "start", "intensiv"];
export const orderedCategories = [...packageCategories].sort((a, b) => categoryOrder.indexOf(a.key) - categoryOrder.indexOf(b.key));

export const singleLessonPrices = [
  { duration: 40, price: "665 kr" },
  { duration: 60, price: "995 kr" },
];

export const vehicle = {
  name: "Volkswagen T-Cross",
  desc: "2 manuell och 2 automat",
  image: "/img/car-transparent.png",
};

export const languages = [
  "Svenska",
  "Engelska",
  "Arabiska",
  "Turkiska",
  "Kurdiska",
  "Persiska",
];

export const riskutbildning = [
  {
    title: "Riskettan (del 1)",
    text: "Riskutbildning del 1 ger dig kunskap om hur alkohol, andra droger, trötthet och andra beteenden påverkar körförmågan. Kurslängd 3 timmar exklusive raster.",
  },
  {
    title: "Halkbana (del 2)",
    text: "Risktvåan handlar om hastighet, säkerhet och körning vid olika väg- och väderförhållanden. Själva utbildningen tar 3 timmar exklusive raster – vi skjutsar dig till och från halkbanan, så räkna med 6 timmar totalt. Båda delarna krävs för att få göra kunskaps- och körprovet.",
  },
  {
    title: "Teori",
    text: "Digital teoribok och egen inloggning till online teoritester – tillgängligt på sex språk så att du kan plugga i din egen takt inför kunskapsprovet.",
  },
];

export const about = {
  intro:
    "City Trafikskola Uppsala AB finns i fräscha lokaler vid Kvarntorget och erbjuder en komplett utbildning för dig som vill ta körkort.",
  body:
    "Vi erbjuder körkortsutbildning för B-behörighet i en rad olika paket och kurskombinationer. Vi tillhandahåller även riskutbildningar (riskettan och halkbana), teori samt intensivutbildning. Teoridelen finns tillgänglig på sex språk och våra lärare undervisar på flera språk.",
  image: "/img/reception.jpg",
  stats: [
    { value: "6", label: "Språk för teori" },
    { value: "4", label: "Bilar (manuell & automat)" },
    { value: "B", label: "Behörighet" },
    { value: "100%", label: "Personligt fokus" },
  ],
};

// Real Google reviews for City Trafikskola i Uppsala (Place ID ChIJUdfNvf7LX0YRQ6H9GWeaChI)
export const googleReviews = {
  rating: "4,8",
  count: 254,
  url: "https://search.google.com/local/reviews?placeid=ChIJUdfNvf7LX0YRQ6H9GWeaChI",
  writeUrl: "https://search.google.com/local/writereview?placeid=ChIJUdfNvf7LX0YRQ6H9GWeaChI",
};

export const reviews = [
  {
    name: "Yelda Batman",
    date: "September 2026",
    rating: 5,
    text: "Jag vill gärna dela med mig av min fantastiska upplevelse på City körskolan, särskilt med min lärare, Belma. När jag började mina lektioner hade jag ingen aning om hur man körde en bil. Jag var helt nybörjare och kände mig osäker. Från första stund visade Belma en otrolig omtanke och tålamod. Hon var mer än bara en lärare; hon var en fantastisk guide och mentor. Hennes förmåga att alltid ha hopp och tro på mig gjorde en enorm skillnad i mitt lärande. Efter varje lektion kände jag att mitt självförtroende växte, och hon kämpade verkligen för att jag skulle lyckas. Idag, när jag tog körkortet, var det en känslomässig stund. Belma var med mig i bilen och jag såg hur hon grät av glädje när jag fick godkänt. Den empati och det engagemang hon visade är sällsynt, och jag är så tacksam för hennes stöd och vägledning. Jag kan utan tvekan säga att City körskolan är den bästa i Sverige! Tack, Belma, för allt du har gjort för mig!",
  },
  {
    name: "Ayse Beydogan",
    date: "Augusti 2026",
    rating: 5,
    text: "Jag tog körkortet idag! Ett stort tack till körskolan och framför allt min fantastiska lärare Belma. Tack för ditt tålamod, ditt stöd och för att du alltid trodde på mig. Du har varit en otrolig lärare och gjort hela resan mycket tryggare och roligare. Jag kan varmt rekommendera 100 % både körkortsskola och min lärare Belma till alla som vill ta körkort!",
  },
  {
    name: "Stefan Karlsson",
    date: "Maj 2026",
    rating: 5,
    text: "Snabbt, tryggt o enkelt. Låter lite som en reklamfilm, men passar perfekt här. Kortet på första, tålmodiga lärare och en hel del skratt!",
  },
  {
    name: "Wayne Metzger",
    date: "Mars 2026",
    rating: 5,
    text: "Adam var jätte bra! Var entusiastisk och förklarade allt på ett förståligt sätt. Trots att jag har kört bil i många år lärde jag mig en hel del. Strongly Recommended!",
  },
  {
    name: "Lara Machado Jonsson",
    date: "Februari 2026",
    rating: 5,
    text: "Har haft bara bra lärare, jag fick mitt körkort på första försöket tack vare Belma!",
  },
  {
    name: "Thathsara Radeeka",
    date: "Februari 2026",
    rating: 5,
    text: "Som ny i Sverige och Uppsala var det mycket viktigt för mig att välja rätt körskola. Jag valde inledningsvis ut de fyra bästa trafikskolorna i Uppsala baserat på Googles recensioner och besökte alla. City Trafikskola i Uppsala stack omedelbart ut, främst på grund av hur Suleyman behandlade mig från första mötet. På grund av det positiva första intrycket bestämde jag mig utan några tvekan för att välja City Trafikskola i Uppsala.",
  },
];

export const gallery = [
  "/img/reception.jpg",
  "/img/uppsala.webp",
  "/img/car.webp",
  "https://images.unsplash.com/photo-1553782097-130fef5d3e27?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxkcml2aW5nJTIwc2Nob29sfGVufDB8fHx8MTc5MDE1NDMzNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1527593167147-e9c94a5883e6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxkcml2aW5nJTIwc2Nob29sfGVufDB8fHx8MTc5MDE1NDMzNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1630406144797-821be1f35d75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwyfHxkcml2aW5nJTIwc2Nob29sfGVufDB8fHx8MTc5MDE1NDMzNnww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1516862523118-a3724eb136d7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxkcml2aW5nJTIwc2Nob29sfGVufDB8fHx8MTc5MDE1NDMzNnww&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/227730/pexels-photo-227730.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/9518021/pexels-photo-9518021.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/9518024/pexels-photo-9518024.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  "https://images.pexels.com/photos/7144214/pexels-photo-7144214.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
];
